<template>
    <el-dialog title="库存分布查询" :visible.sync="dialogVisible" width="80%" append-to-body :close-on-click-modal="false" :close-on-press-escape="true" @opened="onDialogOpened" @close="onDialogClose"
               class="stock-distribution-dialog">
        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" size="small" @submit.native.prevent="searchStockDistribution">
                <el-form-item label="商品编码:">
                    <el-input v-model="searchForm.bgmCode" placeholder="请输入商品编码" style="width: 200px;" clearable @keyup.enter.native="searchStockDistribution" ref="searchInput"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchStockDistribution" :loading="loading">
                        <i class="el-icon-search"></i> 查询
                    </el-button>
                    <el-button @click="resetSearch">
                        <i class="el-icon-refresh"></i> 重置
                    </el-button>
                </el-form-item>
                <el-form-item class="total-stock-item">
                    <div class="total-stock-display">
                        <span class="stock-label">总部库存数量：</span>
                        <span class="stock-value">{{ totalStock }}</span>
                    </div>
                </el-form-item>
            </el-form>
        </div>

        <!-- 库存分布列表 -->
        <div class="stock-list-section">
            <el-table :data="stockList" border size="mini" max-height="400" :loading="loading" empty-text="暂无库存分布数据">
                <template v-for="(tableValye, tableKey) in formList.jurconfigform">
                    <el-table-column v-if="tableValye.isShow == 1" :key="tableKey" :prop="tableValye.entityField" :label="tableValye.showField" width="120" show-overflow-tooltip>
                        <template slot-scope="scope">
                            <span v-if="tableValye.fieldType == 'date' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                            </span>
                            <span v-else-if="tableValye.fieldType == 'dateTime' && scope.row[tableValye.entityField]">
                                {{ $common.getLocalTime(scope.row[tableValye.entityField], true) }}
                            </span>
                            <el-tag size="mini" v-else-if="tableValye.fieldType == 'formatter'">{{
                                    $common.getIsGsp(tableValye.formatterContent, scope.row[tableValye.entityField]) }}</el-tag>
                            <span v-else-if="tableValye.entityField == 'num'" :class="{'low-stock': scope.row.num <= 10, 'zero-stock': scope.row.num <= 0}">{{ scope.row.num }}</span>
                            <span v-else>{{ scope.row[tableValye.entityField] }}</span>
                        </template>
                    </el-table-column>
                </template>
            </el-table>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">关闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
export default {
    name: 'StockDistributionDialog',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        parentSearchData: {
            type: Object,
            require: {},
        },
        formList: {
            type: Object,
            require: {},
        },
    },
    data() {
        return {
            searchForm: {
                bgmCode: ''
            },
            stockList: [],
            loading: false,
            isFirstOpen: true,
            totalStock: 0
        };
    },
    computed: {
        dialogVisible: {
            get() {
                if (this.visible) {
                    // 仅在首次打开时同步数据
                    if (this.isFirstOpen) {
                        for (const key in this.searchForm) {
                            if (this.parentSearchData[key] != "" && this.parentSearchData[key] != null && this.parentSearchData[key] != undefined) {
                                this.searchForm[key] = this.parentSearchData[key];
                            }
                        }
                        this.isFirstOpen = false;
                        if (this.searchForm.bgmCode) {
                            this.searchStockDistribution()
                        }
                    }
                } else {
                    // 对话框关闭时重置标志位
                    this.isFirstOpen = true;
                }
                return this.visible;
            },
            set(val) {
                this.$emit('update:visible', val);
            }
        },
        // 有库存的门店数量
        stockStoreCount() {
            return this.stockList.filter(item => item.num > 0).length;
        }
    },
    methods: {
        // 弹窗打开事件
        onDialogOpened() {
            this.totalStock = 0;
            this.$emit('opened');
            // 自动聚焦到搜索框
            this.$nextTick(() => {
                if (this.$refs.searchInput) {
                    this.$refs.searchInput.focus();
                }
            });
        },

        // 弹窗关闭事件
        onDialogClose() {
            this.$emit('close');
            this.resetSearch();
        },

        // 搜索库存分布
        async searchStockDistribution() {
            if (!this.searchForm.bgmCode || !this.searchForm.bgmCode.trim()) {
                this.$message.warning('请输入商品编码');
                return;
            }

            this.loading = true;
            try {
                // 调用库存分布查询接口
                const response = await this.$http.deraBgmTypeBgsDistributeByBgmCode({
                    ids: [this.searchForm.bgmCode.trim()]
                });

                if (response && response.status === 200) {
                    this.stockList = response.result.list || [];
                    this.totalStock = response.result.zbNum;

                } else {
                    this.$message.error(response.message || '查询失败');
                    this.stockList = [];
                }
            } catch (error) {
                this.$message.error(error.message || '查询失败');
                this.stockList = [];
            } finally {
                this.loading = false;
            }
        },

        // 重置搜索
        resetSearch() {
            this.searchForm.bgmCode = '';
            this.stockList = [];
            this.loading = false;
            this.totalStock = 0;
        }
    }
};
</script>

<style scoped>
.stock-distribution-dialog {
    padding: 10px 0;
}

.search-section {
    margin-bottom: 15px;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 4px;
}

.stock-list-section {
    margin-bottom: 15px;
}

.summary-section {
    padding: 15px;
    background-color: #f0f9ff;
    border-radius: 4px;
    border-left: 4px solid #409eff;
}

.summary-item {
    text-align: center;
    padding: 5px 0;
}

.summary-item .label {
    color: #606266;
    font-size: 14px;
}

.summary-item .value {
    color: #303133;
    font-size: 16px;
    font-weight: bold;
    margin-left: 5px;
}

.low-stock {
    color: #e6a23c;
    font-weight: bold;
}

.zero-stock {
    color: #f56c6c;
    font-weight: bold;
}

/* 总部库存显示样式 */
.total-stock-item {
    margin-left: auto;
    margin-bottom: 0 !important;
}

.total-stock-display {
    display: flex;
    align-items: center;
    padding: 5px 10px;

    white-space: nowrap;
}

.stock-label {
    color: #000;
    font-size: 14px;
    font-weight: 500;
    margin-right: 8px;
}

.stock-value {
    color: #000;
    font-size: 16px;
    font-weight: bold;

    padding: 2px 8px;
    border-radius: 10px;
    min-width: 40px;
    text-align: center;
}

/* 表单布局优化 */
::v-deep .search-section .el-form {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

::v-deep .search-section .el-form-item {
    margin-bottom: 0;
}

.dialog-footer {
    text-align: right;
}

::v-deep .el-form .el-form-item label {
    color: #000 !important;
}
</style>
